<ng-container *ngIf="!isRefreshedUIEnabled; else refreshedUi">
    <div id="summary-box" class="box-shadow">
    <div id="solution-groups" class="summary-section">
        <!-- Apply different pipes based on how large numbers are -->
        <span class="number" *ngIf="sumSolutionGroups >= 1000000">{{sumSolutionGroups | million}}</span>
        <span class="number" *ngIf="sumSolutionGroups < 1000000">{{sumSolutionGroups | number:'1.0-0'}}</span>
        <span class="label">Solution Groups</span>
    </div>
    <div id="locations" class="summary-section">
        <span class="number" *ngIf="sumLocations >= 1000000">{{sumLocations | million}}</span>
        <span class="number" *ngIf="sumLocations < 1000000">{{sumLocations | number:'1.0-0'}}</span>
        <span class="label">Locations</span>
    </div>
    <div id="solutions-per-location" class="summary-section">
        <span class="number">{{solutionsPerLocation | number:'1.1-1'}}</span>
        <span class="label">Solutions Per Location</span>
    </div>
    <div id="sales" class="summary-section">
        <span class="number" *ngIf="sumSales >= 1000000">{{currencySymbol}}{{sumSales | million}}</span>
        <span class="number" *ngIf="sumSales < 1000000">{{currencySymbol}}{{sumSales | number:'1.0-0'}}</span>
        <span class="label">Sales</span>
    </div>
    <div id="products" class="summary-section">
        <span class="number" *ngIf="sumProducts >= 1000000">{{sumProducts | million}}</span>
        <span class="number" *ngIf="sumProducts < 1000000">{{sumProducts | number:'1.0-0'}}</span>
        <span class="label">Products</span>
    </div>
    <div id="cases" class="summary-section">
        <span class="number" *ngIf="sumCases >= 1000000">{{sumCases | number:'1.0-0'}}</span>
        <span class="number" *ngIf="sumCases < 1000000">{{sumCases | number:'1.0-0'}}</span>
        <span class="label">Cases</span>
    </div>
</div>
</ng-container>

<ng-template #refreshedUi>
    <div id="kpi-summary-section" class="flex bg-neptune-gradient rounded-[28px] p-2">
      <div class="flex w-full items-stretch rounded-[20px] bg-white/15 px-6 py-4">
        @if (!isLoading) {
            <div id="solution-groups" class="flex grow flex-col justify-center gap-1 px-6 pt-2 pb-3 first:pl-0 last:pr-0 border-0 border-r-1 border-solid border-white">
                <span class="text-[20px] font-normal leading-6 text-white">Solution Groups</span>
                <span class="text-[28px] font-bold leading-[32px] text-white">
                    @if (sumSolutionGroups >= 1000000) {
                        {{sumSolutionGroups | million}}
                    } @else {
                        {{sumSolutionGroups | number:'1.0-0'}}
                    }
                </span>
            </div>
            <div id="sales" class="flex grow flex-col justify-center gap-1 px-6 pt-2 pb-3 first:pl-0 last:pr-0 border-0 border-r-1 border-solid border-white">
                <span class="text-[20px] font-normal leading-6 text-white">Sales</span>
                <span class="text-[28px] font-bold leading-[32px] text-white">
                    @if (sumSales >= 1000000) {
                        {{currencySymbol}}{{sumSales | million}}
                    } @else {
                        {{currencySymbol}}{{sumSales | number:'1.0-0'}}
                    }
                </span>
            </div>
            <div id="locations" class="flex grow flex-col justify-center gap-1 px-6 pt-2 pb-3 first:pl-0 last:pr-0 border-0 border-r-1 border-solid border-white">
                <span class="text-[20px] font-normal leading-6 text-white">Locations</span>
                <span class="text-[28px] font-bold leading-[32px] text-white">
                    @if (sumLocations >= 1000000) {
                        {{sumLocations | million}}
                    } @else {
                        {{sumLocations | number:'1.0-0'}}
                    }
                </span>
            </div>
            <div id="solutions-per-location" class="flex grow flex-col justify-center gap-1 px-6 pt-2 pb-3 first:pl-0 last:pr-0 border-0 border-r-1 border-solid border-white">
                <span class="text-[20px] font-normal leading-6 text-white">Solutions Per Locations</span>
                <span class="text-[28px] font-bold leading-[32px] text-white">{{solutionsPerLocation | number:'1.1-1'}}</span>
            </div>
            <div id="products" class="flex grow flex-col justify-center gap-1 px-6 pt-2 pb-3 first:pl-0 last:pr-0 border-0 border-r-1 border-solid border-white">
                <span class="text-[20px] font-normal leading-6 text-white">Products</span>
                <span class="text-[28px] font-bold leading-[32px] text-white">
                    @if (sumProducts >= 1000000) {
                        {{sumProducts | million}}
                    } @else {
                        {{sumProducts | number:'1.0-0'}}
                    }
                </span>
            </div>
            <div id="cases" class="flex grow flex-col justify-center gap-1 px-6 pt-2 pb-3 first:pl-0 last:pr-0">
                <span class="text-[20px] font-normal leading-6 text-white">Cases</span>
                <span class="text-[28px] font-bold leading-[32px] text-white">{{sumCases | number:'1.0-0'}}</span>
            </div>
        } @else {
            <!-- ── Skeleton loader ───────────────────────────────────────────────── -->
            @for (i of [0, 1, 2, 3, 4, 5]; track i) {
                <div class="summary-section-skeleton flex flex-col w-full justify-center gap-2 px-6 first:pl-0 last:pr-0 animate-pulse">
                    <div class="h-5 w-28 bg-white/30 rounded"></div>
                    <div class="h-7 w-16 bg-white/30 rounded"></div>
                </div>
            }
        }
    </div>
  </div>
</ng-template>
